import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppointmentScheduler from './components/AppointmentScheduler';

const App: React.FC = () => {
  console.log('App component rendering');
  
  return (
    <BrowserRouter>
      <div className="app-container">
        <Routes>
          <Route 
            path="/cmintro/:matterId" 
            element={
              <React.Suspense fallback={<div>Loading...</div>}>
                <AppointmentScheduler />
              </React.Suspense>
            } 
          />
          <Route 
            path="/:staffEmail?" 
            element={<AppointmentScheduler />} 
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;